import { useIntl } from 'react-intl'
import { UpdateOptions, toast } from 'react-toastify'

import ExportReportBtn from 'src/feature/bite/component/ExportReportBtn'
import { useExportAll } from 'src/feature/tasks/context/useMutation'
/* 
import { exportAllCsv } from 'src/feature/bite/helpers/exportCsv';
import { exportAllExcel } from 'src/feature/bite/helpers/exportExcel';
 */

function Export({ tableName }: { tableName: string }) {
  const intl = useIntl()
  /* const { mutateAsync } = useGetAll() */
  const { mutateAsync } = useExportAll(1, 'CreatedDate')

  const toastSuccess: UpdateOptions = {
    render: intl.formatMessage({ id: 'GLOBAL.EXPORT.SUCCESS.PROGRESS' }),
    type: 'success',
    isLoading: false,
    autoClose: 5000,
    closeOnClick: true,
  }

  const toastLoading = intl.formatMessage({ id: 'GLOBAL.EXPORT.LOADING' })
  /* 
  const columns = [
    {
      key: 'fullname',
      dataIndex: 'fullName',
      title: intl.formatMessage({ id: 'MEMBER.LIST.NAME' }),
      render: (text: string, record: any) => {
        return `${record.name} ${record.surname}`
      },
    },
    { key: 'status', dataIndex: 'status', title: intl.formatMessage({ id: 'MEMBER.LIST.STATUS' }), status: true },
    { key: 'netpoints', dataIndex: 'netPoints', title: intl.formatMessage({ id: 'MEMBER.LIST.NET_POINTS' }) },
    { key: 'worth', dataIndex: 'worth', title: intl.formatMessage({ id: 'MEMBER.LIST.WORTH' }) },
    { key: 'savings', dataIndex: 'savings', title: intl.formatMessage({ id: 'MEMBER.LIST.SAVING' }) },
    { key: 'mobile', dataIndex: 'mobile', title: intl.formatMessage({ id: 'MEMBER.LIST.MOBILE_PHONE' }) },
    { key: 'email', dataIndex: 'email', title: intl.formatMessage({ id: 'MEMBER.LIST.EMAIL' }) },
    {
      key: 'enrollmentdate', dataIndex: 'enrollmentDate', title: intl.formatMessage({ id: 'MEMBER.LIST.ENROLLMENT_DATE' }),
      render: (text: string) => {
        if (!text || text === '0001-01-01T00:00:00Z') return '-';
        return new Date(text).toLocaleDateString('tr-TR') + ' ' + new Date(text).toLocaleTimeString('tr-TR', { hour: 'numeric', minute: 'numeric' })
      }
    },
    { key: 'zip', dataIndex: 'zipCode', title: intl.formatMessage({ id: 'MEMBER.LIST.ZIP_CODE' }) }
  ]
 */
  const getAllCsv = async () => {
    const toastId = toast.loading(toastLoading)
    const data = await mutateAsync(1)

    /*exportAllCsv(tableName, data, columns); */

    toast.update(toastId, toastSuccess)
  }

  const getAllExcel = async () => {
    const toastId = toast.loading(toastLoading)
    const data = await mutateAsync(2)

    /* exportAllExcel(tableName, data, columns); */

    toast.update(toastId, toastSuccess)
  }

  return (
    <>
      <ExportReportBtn
        exportTable={tableName}
        exportAllCsv={getAllCsv}
        exportAllExcel={getAllExcel}
      />
    </>
  )
}

export default Export
